// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EmailVerificationPrompt from './EmailVerificationPrompt'; // Import the prompt component

// This component wraps routes that require authentication AND email verification
function ProtectedRoute({ element }) { // Accepts the component/element to render
  const { currentUser, loadingAuth } = useAuth();

  if (loadingAuth) {
    // Optional: Show a loading indicator while checking auth state
    // Or return null/empty fragment if AuthProvider handles global loading state display
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <div>Checking authentication...</div>
        </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (!currentUser.emailVerified) {
    // If logged in BUT email is not verified, show the verification prompt
    return <EmailVerificationPrompt />;
  }

  // If logged in AND email is verified, render the requested component/element
  return element;
}

export default ProtectedRoute;